import Image from 'next/image'
import Link from 'next/link'

import { Button, Heading, Paragraph } from '@graftcode/design-system'

import type { LearningPath } from '@/modules/academy/academy.interface'
import { LEARNING_PATHS_SECTION_TEST_IDS } from '@/shared/academy-test-ids.const'

import type { PathProgress } from '../../hooks/useLearningPathProgress'

import styles from './LearningPathCard.module.scss'

type LearningPathCardProps = {
  path: LearningPath
  progress?: PathProgress
}

export function LearningPathCard({ path, progress }: LearningPathCardProps) {
  return (
    <div className={styles.row} data-testid={LEARNING_PATHS_SECTION_TEST_IDS.card}>
      <div className={styles.image}>
        <Image src={path.imageSrc} alt={path.imageAlt} fill className={styles.img} />
      </div>
      <div className={styles.content}>
        <div className={styles.titleGroup}>
          <Heading className={styles.title} type="h3">
            {path.title}
          </Heading>
          <Paragraph className={styles.description}>{path.description}</Paragraph>
        </div>
        {progress ? (
          <>
            <div className={styles.progressContainer}>
              <div className={styles.progressBar}>
                <div className={styles.progressFill} style={{ width: `${progress.percentage}%` }} />
              </div>
              <span className={styles.progressText}>{progress.progressText}</span>
            </div>
            <Link href={path.href}>
              <Button variant="subtle-fill" size="m">
                {progress.hasStarted ? 'Continue' : 'Start course'}
              </Button>
            </Link>
          </>
        ) : (
          <Link href={path.href}>
            <Button variant="subtle-fill" size="m">
              Start course
            </Button>
          </Link>
        )}
      </div>
    </div>
  )
}
